import { useBaseViewModel } from '@/common';
import { CourseTopicEntity } from '@/domains/course-topic/entities';
import { CourseTopicPayloadForm } from '@/domains/course-topic/ports/payloads';
import {
  CreateCourseTopicUsecase,
  UpdateCourseTopicUsecase,
} from '@/domains/course-topic/usecases';
import { notification } from 'antd';
import { useState } from 'react';
import { validateCourseTopic } from '../validations';
import { CourseTopicHttpRepository } from '../adapters/repositories';
import { getErrorMessage } from '@/components/hooks/useGetErrorMessage';

export default function CourseTopicFormViewModel(props?: {
  detailCourseTopic?: CourseTopicEntity;
}) {
  const createCourseTopicUC = new CreateCourseTopicUsecase(new CourseTopicHttpRepository());
  const updateCourseTopicUC = new UpdateCourseTopicUsecase(new CourseTopicHttpRepository());
  const { loading, error, catchAction } = useBaseViewModel();
  const [courseLineData, setCourseTopicData] = useState<CourseTopicEntity>();

  const actionSaveCourseTopic = async (payload: CourseTopicPayloadForm) => {
    try {
      if (payload.id) {
        const data = await updateCourseTopicUC.run(payload);
        setCourseTopicData(data);
        notification.success({
          message: 'Course Topic Updated',
          description: 'You have successfully updated the course topic',
          placement: 'bottomRight',
        });
      } else {
        const data = await createCourseTopicUC.run(payload);
        setCourseTopicData(data);
        notification.success({
          message: 'Course Topic Created',
          description: 'You have successfully created a new course topic',
          placement: 'bottomRight',
        });
      }
      return true;
    } catch (error) {
      notification.error({
        message: 'Error',
        description: getErrorMessage(error),
        placement: 'bottomRight',
      });
      return false;
    }
  };

  const validateForm = (props: { detailCourseTopic: CourseTopicEntity }) => {
    const { schemaCourseTopic } = validateCourseTopic(props);
    return { schemaCourseTopic };
  };

  return {
    loading,
    error,
    courseLineData,
    actionSaveCourseTopic,
    validateForm,
  };
}
